import { defineComponent as _defineComponent } from 'vue'
import BKButton from '@/components/AppShared/BKButton.vue'
import { UserDB } from '@/enitites/user'
import useValidationRules from '@/shared/composables/validation'
import { computed, ref, watch } from 'vue'
import { useCloned } from '@vueuse/core'
import OnboardingFormLayout from './OnboardingFormLayout.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingFullNameForm',
  props: {
    currentStep: { default: 0 },
    error: { default: '' },
    loading: { type: Boolean, default: false },
    steps: { default: 0 },
    user: null
  },
  emits: ["submitForm"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'submitForm', value: UserDB): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { currentStep: number, error: string, loading: boolean, steps: number, user: UserDB };




const user = ref(useCloned(props.user).cloned)

const rules = useValidationRules()
const firstName = ref(user.value.fullName.split(' ')[0])
const lastName = ref(user.value.fullName.split(' ')[1])
const fullName = computed(() => `${firstName.value} ${lastName.value}`)
const lastNameRef = ref<HTMLInputElement | null>(null)
const valid = ref(true)

watch(
  () => fullName.value,
  () => {
    user.value.fullName = fullName.value
  }
)

return { __sfc: true,props, emit, user, rules, firstName, lastName, fullName, lastNameRef, valid, BKButton, OnboardingFormLayout }
}

})